var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('codemirror',{staticClass:"code-editor",attrs:{"value":_vm.value,"options":_vm.codeMirrorOptions},on:{"input":function (val) { return _vm.$emit('input', val); }}})}
var staticRenderFns = []

export { render, staticRenderFns }